let elements = [];
let containers = [];
window.confettiful = null;
const Confettiful = function(el) {
    for (let i = 0; i < el.length; i++) {
        elements[i] = el[i];
        containers[i] = null;

        this.confettiColors = ['#666666', '#C9C9CB', '#EBB300', '#FFC705'];
        this.confettiAnimations = ['slow', 'medium', 'fast'];

        this._setupElements(i);
        this._renderConfetti(i);
    }
};

Confettiful.prototype._setupElements = function(i) {
    const containerEl = document.createElement('div');

    containerEl.classList.add('confetti-container');

    elements[i].appendChild(containerEl);

    containers[i] = containerEl;
};

Confettiful.prototype._renderConfetti = function(i) {
    this.confettiInterval = setInterval(() => {
        // Only add new confetti when above mobile width
        if (window.innerWidth > 959) {
            const confettiEl = document.createElement('div');
            const confettiSize = Math.random() * 2 + 10 + 'px';
            const confettiBackground = this.confettiColors[Math.floor(Math.random() * this.confettiColors.length)];
            const confettiLeft = Math.random() * elements[i].offsetWidth + 'px';
            const confettiAnimation = this.confettiAnimations[
                Math.floor(Math.random() * this.confettiAnimations.length)
            ];

            confettiEl.classList.add('confetti', 'confetti--animation-' + confettiAnimation);
            confettiEl.style.left = confettiLeft;
            confettiEl.style.width = confettiSize;
            confettiEl.style.height = confettiSize;
            confettiEl.style.backgroundColor = confettiBackground;

            confettiEl.removeTimeout = setTimeout(function() {
                confettiEl.parentNode.removeChild(confettiEl);
            }, 10000);

            containers[i].appendChild(confettiEl);
        }
    }, 150);
};

function Init() {
    // Only init when above mobile width
    if (window.innerWidth > 959 && window.confettiful === null) {
        window.confettiful = new Confettiful(document.querySelectorAll('.confetti-container-container'));
    }
}

$().ready(function() {
    Init();
});

$(window).resize(function() {
    Init();
});
